import { Button, useDisclosure } from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';

import { QuoteCarrierHeader } from '../components/quote';
import { ReportsViewerModal } from '../components/validations';
import ValidationsSummary from 'views/validated_policy/components/ValidationsSummary';
import type { AutoValidationsData } from 'api';
import type { UseDriverReportsReturn } from '../hooks';

interface AutoValidationsStepProps {
  data: AutoValidationsData;
  quoteId: number;
  driverReports: UseDriverReportsReturn;
  onOpenDiscrepancyModal: () => void;
  validations: Validation[];
}

const AutoValidationsStep = ({
  data,
  quoteId,
  driverReports,
  onOpenDiscrepancyModal,
  validations,
}: AutoValidationsStepProps) => {
  const {
    isOpen: isReportsModalOpen,
    onOpen: openReportsModal,
    onClose: closeReportsModal,
  } = useDisclosure();

  if (!data.selected_carrier) {
    return null;
  }

  const handleViewDiscrepancies = () => {
    if (driverReports.hasDiscrepancies) {
      onOpenDiscrepancyModal();
    }
  };

  return (
    <>
      <QuoteCarrierHeader
        carrierName={data.selected_carrier.carrier_name}
        quoteRef={data.selected_carrier.acturis_quote_ref}
        actions={
          <>
            <Button
              size="sm"
              leftIcon={<ViewIcon />}
              variant="outline"
              onClick={openReportsModal}
              isDisabled={!data.reports_available}
            >
              View Reports
            </Button>
            <Button
              size="sm"
              leftIcon={<ViewIcon />}
              variant="outline"
              onClick={handleViewDiscrepancies}
              isDisabled={!data.discrepancies_available}
            >
              View Discrepancies
            </Button>
          </>
        }
      />

      {validations.length > 0 && (
        <ValidationsSummary validations={validations} />
      )}

      <ReportsViewerModal
        isOpen={isReportsModalOpen}
        onClose={closeReportsModal}
        quoteId={quoteId}
        mvrReports={data.mvr_reports}
        dashReports={data.dash_reports}
      />
    </>
  );
};

export default AutoValidationsStep;
